import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { IProductAvailability } from 'src/graphql/types';
import { availabilityRoute } from '../route';
import { PlantForm } from './plant-form';

const PlantDropDown: FC<{
  productAvailability: IProductAvailability;
  shipToId: string;
  productId: string;
  isExtended: boolean;
}> = ({ productAvailability, shipToId, productId, isExtended }) => {
  const history = useHistory();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    if (e.target.value === '-1') {
      return;
    }
    e.preventDefault();
    history.push(
      availabilityRoute(shipToId, {
        productId,
        plantId: e.target.value,
      })
    );
  };

  return (
    <PlantForm
      onSubmit={handleSubmit}
      onChange={handleChange}
      alternativePlants={
        isExtended
          ? productAvailability.extendedPlants
          : productAvailability.alternativePlants
      }
    />
  );
};

export { PlantDropDown };
